import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { MaterialPlanejamentoOficina } from '../../../../core/materiais-planejamento-oficina';

@Component({
  selector: 'listar-materiais',
  templateUrl: './listar-materiais.component.html',
  styleUrls: ['./listar-materiais.component.css']
})
export class ListarMateriaisComponent implements OnInit {

  @Output() onAtualizarMaterial = new EventEmitter();
  @Output() onAdicionar = new EventEmitter();

  @Input() materiaisPlanejamentosOficinas: MaterialPlanejamentoOficina[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['material', 'datainicio', 'quantidade', 'acoes'];
  dataSource: MatTableDataSource<MaterialPlanejamentoOficina> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.carregarLista();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["materiaisPlanejamentosOficinas"] && !_.isEmpty(changes["materiaisPlanejamentosOficinas"].currentValue)) {
      this.carregarLista();
    }
  }

  carregarLista() {
      if (_.isEmpty(this.materiaisPlanejamentosOficinas)) {
        this.mostrarTabela = false;
        this.msg = 'Nenhum material cadastrado.';
      } else {
        this.dataSource.data = this.materiaisPlanejamentosOficinas;
        this.mostrarTabela = true;
    }
  }

  deletar(materialAtividade: any): void {
    const index = this.materiaisPlanejamentosOficinas.indexOf( this.materiaisPlanejamentosOficinas.find(col => col === materialAtividade));
    if (index >= 0) {
      this.materiaisPlanejamentosOficinas.splice(index, 1);
      this.carregarLista();
    }
  }

  atualizar(materialPlanejamentoOficina: MaterialPlanejamentoOficina) {
    this.onAtualizarMaterial.emit(materialPlanejamentoOficina);
  }

  novo() {
    this.onAdicionar.emit(true);
  }

}
